import React from "react";
import { Link } from "react-router-dom";
import { Socials } from "../home";

const TermsOfService = () => {
  return (
    <div className="min-h-screen relative overflow-hidden mt-20">
      <div className="container mx-auto px-4 py-16 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center animate-fade-in">
          Terms of Service
        </h1>

        <div
          className="max-w-4xl mx-auto text-white/80 space-y-6 text-lg animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <p className="text-center text-market-teal">
            Effective Date: April 1, 2025
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            The Agreement
          </h2>
          <p>
            The use of this website and services on this website provided by
            marketpulse.exchange (hereinafter referred to as "Owner") are
            subject to the following Terms & Conditions (hereinafter the "Terms
            of Service"), all parts and sub-parts of which are specifically
            incorporated by reference here together with the Privacy Policy.
          </p>
          <p>
            These Terms of Service govern your use of
            https://marketpulse.exchange/ (the "Website"), all pages on the
            Website, and any services provided by or on this Website
            ("Services").
          </p>
          <p>
            By accessing, either directly or through a hyperlink, the Website
            and/or purchasing something from us, you engage in our "Service" and
            agree to be bound by the Terms of Service including those additional
            terms and policies referenced herein and/or available by hyperlink.
            These Terms of Service apply to all users of the site, including
            without limitation vendors, buyers, customers, merchants, browsers,
            and/or contributors of content. You acknowledge and agree that the
            Website may use your personal information in the manner described in
            our Privacy Policy.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            1. Definitions
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Owner, Us, We: Refers to marketpulse.exchange, the creator,
              operator, and publisher of the Website and all employees and
              affiliates of the Owner.
            </li>
            <li>
              You, the User, the Client: Refers to any natural or legal person
              who is accessing or using the Website.
            </li>
            <li>Parties: Collectively refers to both the Owner and You.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            2. Assent & Acceptance
          </h2>
          <p>
            By using the Website, you confirm that you have read and understood
            these Terms of Service and agree to be bound by them. If you do not
            agree, please discontinue use immediately.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            3. Age Restriction
          </h2>
          <p>
            You must be at least 18 years of age to use this Website. By using
            this Website, you represent that you are at least 18 and capable of
            entering into a binding agreement.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            4. About the Site
          </h2>
          <p>
            marketpulse.exchange is a digital platform offering technical
            analysis tools, scanner-based alerts, and educational content to
            assist traders. We reserve the right to deny services at any time
            without justification.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            5. License to Use Website
          </h2>
          <p>
            The Owner grants you a non-exclusive, limited, revocable license to
            use the Website and associated materials solely for personal or
            internal business use in line with these Terms.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            6. Intellectual Property
          </h2>
          <p>
            All content, logos, features, and services are the intellectual
            property of the Owner. You agree not to copy, distribute, or reuse
            content without explicit permission.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            7. User Obligations
          </h2>
          <p>
            You must provide accurate information and maintain confidentiality
            of your credentials. Fraudulent or unauthorized use of the platform
            will result in immediate termination.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            8. Payment & Fees
          </h2>
          <p>
            All paid services must be paid for as described at the time of
            purchase. All payments are final and non-refundable.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            9. Acceptable Use
          </h2>
          <p>
            You agree not to misuse the Website, transmit harmful content,
            engage in unlawful conduct, or violate the rights of other users.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            10. Communication
          </h2>
          <p>
            By using the platform, you consent to receive emails and
            communications from us related to your account or services.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            11. Affiliate Marketing & Advertising
          </h2>
          <p>
            We may participate in affiliate marketing and accept sponsorship or
            advertising content.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            12. Privacy Information
          </h2>
          <p>
            We collect and use personal data according to our Privacy Policy.
            Data may be processed in jurisdictions outside India.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            13. Assumption of Risk
          </h2>
          <p>
            All use of our platform is at your own risk. We do not provide
            investment, legal, or medical advice.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            14. Sale of Goods/Services
          </h2>
          <p>
            We strive to accurately represent all services and information but
            do not guarantee accuracy. No refunds will be issued.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            15. Reverse Engineering & Security
          </h2>
          <p>
            You agree not to reverse engineer or bypass security features of the
            Website.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            16. Data Loss
          </h2>
          <p>
            We are not responsible for data loss. Users assume full
            responsibility for safeguarding their data.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            17. Indemnification
          </h2>
          <p>
            You agree to indemnify us against any legal claims resulting from
            your use of the Website or breach of these Terms.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            18. Spam Policy
          </h2>
          <p>
            We strictly prohibit the use of our platform for spamming or
            unsolicited communication.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            19. Third-Party Links & Content
          </h2>
          <p>
            We are not responsible for third-party websites linked through our
            platform.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            20. Modification & Variation
          </h2>
          <p>
            These Terms may be updated at any time. Continued use after updates
            constitutes agreement to new terms.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            21. Entire Agreement
          </h2>
          <p>These Terms constitute the full agreement between the parties.</p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            22. Service Interruptions
          </h2>
          <p>
            We may interrupt service for maintenance or technical reasons and
            are not liable for resulting damages.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            23. Term, Termination & Suspension
          </h2>
          <p>
            We may terminate access for any violation. Some terms survive
            termination.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            24. No Warranties
          </h2>
          <p>
            We provide the platform "as is" and disclaim all warranties, express
            or implied. Use is at your own risk.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            25. Limitation on Liability
          </h2>
          <p>
            Maximum liability is limited to INR 1000 or the amount paid in the
            last 6 months, whichever is lower.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            26. General Provisions
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>Language: English.</li>
            <li>Jurisdiction: Bhopal, Madhya Pradesh, India.</li>
            <li>Assignment: Not permitted without our consent.</li>
            <li>
              Severability: If part is unenforceable, the rest remains valid.
            </li>
            <li>
              Force Majeure: We are not liable for events beyond our control.
            </li>
            <li>Electronic Communications: Accepted as binding.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Refund Policy
          </h2>
          <p>No Refunds. All purchases are final.</p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Disclaimers
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>
              "Investment in securities market are subject to market risks. Read
              all the related documents carefully before investing."
            </li>
            <li>"Past performance is not indicative of future results."</li>
            <li>
              "The securities quoted are for illustration only and are not
              recommendatory."
            </li>
            <li>
              Details shared on social media or platform are for educational
              purposes only and should not be construed as investment advice by
              marketpulse.exchange or Project Options.
            </li>
            <li>We reserve the right to modify disclaimers without notice.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Contact Us
          </h2>
          <p>
            Email:{" "}
            <a
              className="text-market-teal/40 hover:text-market-teal"
              href="mailto://hello@projectoptions.in"
            >
              hello@projectoptions.in
            </a>
          </p>

          <div className="intellectia-card p-8 mt-12 text-center">
            <h3 className="text-xl font-semibold mb-4">Questions?</h3>
            <p className="mb-6">
              If you have any questions about our Terms of Service, please
              contact our support team.
            </p>
            <Socials />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
